import { useEffect } from 'react';
import { cancelPendingRequests } from '../apiCalls';

/**
 * Hook to automatically cancel pending requests on component unmount
 * Prevents "can't perform state update on unmounted component" warnings
 */
export const useCleanupRequests = () => {
    useEffect(() => {
        return () => {
            cancelPendingRequests();
        };
    }, []);
};
